export default class ToTop {
	constructor(config) {
		this.el = config.el;
		this.init();
	}

	init() {
		this.attachEvents();
	}
	attachEvents() {
		this.el.addEventListener("click", (e) => {
			e.preventDefault();

			window.scrollTo({
				top: 0,
				left: 0,
				behavior: "smooth",
			});
		});
	}
}
